import {observer} from 'mobx-react-lite';
import styled from '@emotion/styled';
import React from 'react';
import { RefreshIcon } from 'src/assets/icons/RefreshIcon';
import { mainColors } from 'src/assets/colors';
import { spin } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

const Wrapper = styled('div', { label: 'Wrapper' })`
    display: flex;
    align-items: center;
`;

const Icon = styled(RefreshIcon, { label: 'Icon' })`
    margin-right: 8px;
    animation: ${spin} 3s linear infinite;
`;

const Info = styled('div', { label: 'Info' })`
    display: flex;
    flex-direction: column;
`;

const FileName = styled('span', { label: 'FileName' })`
    font-size: 14px;
    line-height: 1;
    margin-bottom: 4px;
`;

const Status = styled('span', { label: 'Status' })`
    font-size: 12px;
    line-height: 1;
    color: ${mainColors.grays.gray400};
`;

interface PropsType {
    fileName: string;
}

export const FileUploading = observer(({ fileName }: PropsType) => {
    return (
        <Wrapper>
            <Icon/>
            <Info>
                <FileName>{fileName}</FileName>
                <Status>Uploading...</Status>
            </Info>
        </Wrapper>
    );
});

